import request from '@/sheep/request';

const CouponApi = {
  // 获得优惠劵模板列表
  getCouponTemplateListByIds: (ids) => {
    return request({
      url: '/promotion/coupon-template/list-by-ids',
      method: 'GET',
      params: { ids },
      custom: {
        showLoading: false, // 不展示 Loading，避免领取优惠劵时，不成功提示
        showError: false,
      },
    });
  },
  // 获得优惠劵模版列表
  getCouponTemplateList: (spuId, productScope, count) => {
    return request({
      url: '/promotion/coupon-template/list',
      method: 'GET',
      params: { spuId, productScope, count },
    });
  },
  // 获得优惠劵模版分页
  getCouponTemplatePage: (params) => {
    return request({
      url: '/promotion/coupon-template/page',
      method: 'GET',
      params,
    });
  },
  // 获得优惠劵模版
  getCouponTemplate: (id) => {
    return request({
      url: '/promotion/coupon-template/get',
      method: 'GET',
      params: { id },
    });
  },
  // 我的优惠劵列表
  getCouponPage: (params) => {
    return request({
      url: '/promotion/coupon/page',
      method: 'GET',
      params,
    });
  },
  // 我的优惠劵列表
  getExchange: (params) => {
    return request({
      url: '/promotion/coupon/exchange',
      method: 'GET',
      params,
    });
  },

  // 获取商品可用优惠券列表
  getGoodCouponPage: (data) => {
    const data2 = {
      ...data,
    }
    if (!(data.couponId > 0)) {
      delete data2.couponId;
    }
    if (!(data.addressId > 0)) {
      delete data2.addressId;
    }
    if (!(data.combinationActivityId) > 0) {
      delete data2.combinationActivityId;
    }
    if (!(data.combinationHeadId > 0)) {
      delete data2.combinationHeadId;
    }
    if (!(data.seckillActivityId > 0)) {
      delete data2.seckillActivityId;
    }
    delete data2.items
    for (let i = 0; i < data.items.length; i++) {
      data2[encodeURIComponent('items[' + i + '' + '].skuId')] = data.items[i].skuId + '';
      data2[encodeURIComponent('items[' + i + '' + '].count')] = data.items[i].count + '';
      data2[encodeURIComponent('items[' + i + '' + '].spuId')] = data.items[i].spuId + '';
      data2[encodeURIComponent('items[' + i + '' + '].seckillActivityId')] = data.items[i].seckillActivityId + '';
    }
    const queryString = Object.keys(data2)
      .map((key) => key + '=' + data2[key])
      .join('&');
    return request({
      url: `/promotion/coupon/good-page?${queryString}`,
      method: 'GET',
    });
  },
    // 我的珠水优惠劵列表
    getZhushuiCouponPage: (data) => {
      return request({
        url: '/promotion/coupon/zhushui-page',
        method: 'GET',
        data,
      });
    },
  // 根据栏目编码获取优惠券
  getTemplateCouponPage: (params) => {
    return request({
      url: '/promotion/coupon-template/column-page',
      method: 'GET',
      params,
    });
  },
  updateTake: (params) => {
    return request({
      url: '/promotion/coupon/update-take-status',
      method: 'GET',
      params,
    });
  },

  // 获取最优优惠券
  getCouponBest: (params) => {
    return request({
      url: '/promotion/coupon/get-best',
      method: 'GET',
      params,
    });
  },
  // 领取优惠券
  takeCoupon: (templateId) => {
    return request({
      url: '/promotion/coupon/take',
      method: 'POST',
      data: { templateId },
      custom: {
        auth: true,
        showLoading: true,
        loadingMsg: '领取中',
        showSuccess: true,
        successMsg: '领取成功',
      },
    });
  },
  // 获得优惠劵
  getCoupon: (id) => {
    return request({
      url: '/promotion/coupon/get',
      method: 'GET',
      params: { id },
    });
  },
  // 获得未使用的优惠劵数量
  getUnusedCouponCount: () => {
    return request({
      url: '/promotion/coupon/get-unused-count',
      method: 'GET',
      custom: {
        showLoading: false,
        auth: true,
      },
    });
  },
  // 获得匹配指定商品的优惠劵列表
  getMatchCouponList: (price, spuIds, skuIds, categoryIds) => {
    return request({
      url: '/promotion/coupon/match-list',
      method: 'GET',
      params: {
        price,
        spuIds: spuIds.join(','),
        skuIds: skuIds.join(','),
        categoryIds: categoryIds.join(','),
      },
      custom: {
        showError: false,
        showLoading: false, // 避免影响 settlementOrder 结算的结果
      },
    });
  }
};

export default CouponApi;
